import React from 'react';
import {AppGridLayout,AppTable,AppTableSearch,AppSearchItem,AppButton,AppRow} from 'qcc';

export default class extends React.Component {

	render() {
		return (
        <AppGridLayout>
            <AppGridLayout.SearchArea>
                <AppTableSearch>
                    <AppTableSearch.Common>
                        <AppSearchItem.SearchInput placeholder='请录入登录人' keyName='common' field='user_name'/>
                    </AppTableSearch.Common>
                </AppTableSearch>
            </AppGridLayout.SearchArea>
            <AppGridLayout.GridArea>
                <AppTable paging sqlId='sql.audit.loginLogGrid' orderBy='log_time desc,id'>
                    <AppTable.ColIndex />
                    <AppTable.Col title='登录人' field='user_name' />
                    <AppTable.Col title='ip' field='ip' />
                    <AppTable.ColDateTime title='时间' field='log_time' />
                    <AppTable.Col title='设备' render={(data?:any,dataIndex?:number)=>{
                        if(data.is_pos ===1) return 'POS';
                        else return '';
                    }}  />
                </AppTable>
            </AppGridLayout.GridArea>
        </AppGridLayout>)
	}
}


// WEBPACK FOOTER //
// ./src/page/application/audit/IndexLoginGrid.tsx